import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/account"); else setError(res.error);
  };

  return (
    <div className="container-furn flex min-h-[70vh] items-center justify-center py-16">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h1 className="mb-1 font-display text-2xl font-semibold uppercase">Sign In</h1>
        <p className="mb-6 text-sm text-muted-foreground">Welcome back, angler.</p>
        {error && <div data-testid="login-error" className="mb-4 border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <button data-testid="login-submit" disabled={loading} className="w-full bg-accent py-3.5 text-xs font-bold uppercase tracking-widest text-accent-foreground hover:brightness-110 transition-[filter] disabled:opacity-50">{loading ? "Signing in…" : "Sign In"}</button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground">No account? <Link to="/register" className="font-semibold text-accent">Create one</Link></p>
        <p className="mt-4 rounded-sm bg-secondary/60 p-3 text-center text-xs text-muted-foreground">Demo: customer@furnangling.co.uk / Customer2026!</p>
      </div>
    </div>
  );
}
